export const CalendarIcon = ({
  width,
  height,
  fill = 'none',
  stroke = 'white',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 22"
    fill={fill}
  >
    <path
      d="M1.0918 8.40445H18.9157"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4429 12.3097H14.4522"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0054 12.3097H10.0147"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.55818 12.3097H5.56744"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4429 16.1964H14.4522"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0054 16.1964H10.0147"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.55818 16.1964H5.56744"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0433 1V4.29078"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.96515 1V4.29078"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2383 2.5791H5.77096C2.83427 2.5791 1 4.21504 1 7.22213V16.2718C1 19.3261 2.83427 20.9999 5.77096 20.9999H14.229C17.175 20.9999 19 19.3545 19 16.3474V7.22213C19.0092 4.21504 17.1842 2.5791 14.2383 2.5791Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ClockIcon = ({ width, height, fill = 'none' }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
  >
    <path
      d="M11.1748 6.19999V12.1087C11.1748 12.3736 11.3025 12.6223 11.5181 12.777L13.8539 14.4524C13.9998 14.5569 14.1683 14.6071 14.335 14.6071C14.5917 14.6071 14.8448 14.4882 15.0059 14.2647C15.2719 13.8955 15.1876 13.3815 14.8178 13.1158L12.8252 11.6868V6.19999C12.8252 5.74551 12.4557 5.37695 12 5.37695C11.5443 5.37695 11.1748 5.74551 11.1748 6.19999Z"
      fill="#BCBCC2"
    />
    <path
      d="M2.08203 12.1081C2.08203 17.5624 6.53083 21.9994 11.9995 21.9994C17.4682 21.9994 21.9169 17.5624 21.9169 12.1081C21.9169 6.65386 17.4681 2.2168 11.9995 2.2168C6.53091 2.2168 2.08203 6.65386 2.08203 12.1081ZM20.2665 12.1081C20.2665 16.6545 16.5579 20.3534 11.9994 20.3534C7.44096 20.3534 3.73245 16.6545 3.73245 12.1081C3.73245 7.56175 7.44104 3.86287 11.9995 3.86287C16.558 3.86287 20.2665 7.56175 20.2665 12.1081Z"
      fill="#BCBCC2"
    />
    <path
      d="M21.1747 5.89094C21.3859 5.89094 21.5969 5.81053 21.7581 5.64979C22.0804 5.32831 22.0804 4.8075 21.7581 4.48594L19.5073 2.24111C19.185 1.91963 18.6628 1.91963 18.3404 2.24111C18.018 2.56259 18.0181 3.0834 18.3404 3.40496L20.5912 5.64979C20.7524 5.81061 20.9636 5.89094 21.1747 5.89094Z"
      fill="#BCBCC2"
    />
    <path
      d="M4.49251 2.2411L2.24175 4.48601C1.91942 4.80749 1.91942 5.3283 2.24175 5.64986C2.40291 5.8106 2.61408 5.89101 2.82517 5.89101C3.03626 5.89101 3.24743 5.8106 3.4086 5.64986L5.65936 3.40503C5.98169 3.08356 5.98169 2.56274 5.65936 2.24118C5.33703 1.91962 4.81484 1.91962 4.49251 2.2411Z"
      fill="#BCBCC2"
    />
  </svg>
)

export const EditIcon = ({
  width,
  height,
  fill = 'none',
  stroke = '#BCBCC2',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 18 18'}
    fill={fill}
  >
    <path
      d="M9 14.9992H15.75M12.375 2.62419C12.6734 2.32582 13.078 2.1582 13.5 2.1582C13.7089 2.1582 13.9158 2.19936 14.1088 2.27931C14.3019 2.35926 14.4773 2.47646 14.625 2.62419C14.7727 2.77193 14.8899 2.94732 14.9699 3.14035C15.0498 3.33338 15.091 3.54026 15.091 3.74919C15.091 3.95813 15.0498 4.16501 14.9699 4.35804C14.8899 4.55107 14.7727 4.72646 14.625 4.87419L5.25 14.2492L2.25 14.9992L3 11.9992L12.375 2.62419Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ProtectIcon = ({ width, height, fill = 'none' }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 18 18'}
    fill={fill}
  >
    <path
      d="M9 16.5C9 16.5 15 13.5 15 9V3.75L9 1.5L3 3.75V9C3 13.5 9 16.5 9 16.5Z"
      stroke="#BCBCC2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const VisaCardIcon = ({ width, height, fill = 'none' }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 48 48'}
    fill={fill}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9171 26.4304H14.4842L11.9099 16.3206C11.7877 15.8556 11.5283 15.4444 11.1467 15.2507C10.1943 14.7637 9.14486 14.3762 8 14.1807V13.7915H13.5301C14.2934 13.7915 14.8658 14.3762 14.9612 15.0552L16.2969 22.3477L19.7281 13.7915H23.0656L17.9171 26.4304ZM24.9737 26.4304H21.7316L24.4013 13.7915H27.6434L24.9737 26.4304ZM31.8378 17.2929C31.9332 16.6121 32.5057 16.2229 33.1735 16.2229C34.223 16.1252 35.3661 16.3206 36.3202 16.8059L36.8926 14.0847C35.9386 13.6955 34.8891 13.5 33.9367 13.5C30.7901 13.5 28.5003 15.2507 28.5003 17.6804C28.5003 19.5288 30.1222 20.4993 31.2671 21.084C32.5057 21.667 32.9827 22.0563 32.8873 22.6393C32.8873 23.5137 31.9332 23.903 30.9809 23.903C29.836 23.903 28.6911 23.6115 27.6434 23.1245L27.0709 25.8474C28.2158 26.3327 29.4544 26.5281 30.5992 26.5281C34.1276 26.6242 36.3202 24.8752 36.3202 22.25C36.3202 18.9441 31.8378 18.7504 31.8378 17.2929ZM47.6667 26.4304L45.0924 13.7915H42.3273C41.7549 13.7915 41.1825 14.1807 40.9917 14.7637L36.2248 26.4304H39.5623L40.2284 24.5837H44.3292L44.7108 26.4304H47.6667ZM42.8044 17.1951L43.7567 21.9585H41.0871L42.8044 17.1951Z"
      fill="#337FF5"
    />
  </svg>
)

export const FeedIcon = ({
  width,
  height,
  fill = 'none',
  stroke = 'white',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 20 20'}
    fill={fill}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25 1.5C1.5 1.5 1.5 1.708 1.5 4.25V4.275C1.5 5.382 1.5 6.182 1.771 6.52C2.036 6.848 2.823 7 4.25 7C5.677 7 6.464 6.847 6.729 6.519C7 6.182 7 5.382 7 4.274C7 1.708 7 1.5 4.25 1.5ZM4.25 8.5C2.564 8.5 1.299 8.323 0.604 7.46C0 6.711 0 5.689 0 4.275L0.75 4.25H0C0 1.38 0.181 0 4.25 0C8.319 0 8.5 1.38 8.5 4.25C8.5 5.688 8.5 6.711 7.896 7.46C7.201 8.323 5.936 8.5 4.25 8.5Z"
      fill={stroke}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.25 1.5C12.5 1.5 12.5 1.708 12.5 4.25V4.275C12.5 5.382 12.5 6.182 12.771 6.52C13.036 6.848 13.823 7 15.25 7C16.677 7 17.464 6.847 17.729 6.519C18 6.182 18 5.382 18 4.274C18 1.708 18 1.5 15.25 1.5ZM15.25 8.5C13.564 8.5 12.299 8.323 11.604 7.46C11 6.711 11 5.689 11 4.275L11.75 4.25H11C11 1.38 11.181 0 15.25 0C19.319 0 19.5 1.38 19.5 4.25C19.5 5.688 19.5 6.711 18.896 7.46C18.201 8.323 16.936 8.5 15.25 8.5Z"
      fill={stroke}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25 12.5C1.5 12.5 1.5 12.708 1.5 15.25V15.275C1.5 16.382 1.5 17.182 1.771 17.52C2.036 17.848 2.823 18 4.25 18C5.677 18 6.464 17.847 6.729 17.519C7 17.182 7 16.382 7 15.274C7 12.708 7 12.5 4.25 12.5ZM4.25 19.5C2.564 19.5 1.299 19.323 0.604 18.46C0 17.711 0 16.689 0 15.275L0.75 15.25H0C0 12.38 0.181 11 4.25 11C8.319 11 8.5 12.38 8.5 15.25C8.5 16.688 8.5 17.711 7.896 18.46C7.201 19.323 5.936 19.5 4.25 19.5Z"
      fill={stroke}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.25 12.5C12.5 12.5 12.5 12.708 12.5 15.25V15.275C12.5 16.382 12.5 17.182 12.771 17.52C13.036 17.848 13.823 18 15.25 18C16.677 18 17.464 17.847 17.729 17.519C18 17.182 18 16.382 18 15.274C18 12.708 18 12.5 15.25 12.5ZM15.25 19.5C13.564 19.5 12.299 19.323 11.604 18.46C11 17.711 11 16.689 11 15.275L11.75 15.25H11C11 12.38 11.181 11 15.25 11C19.319 11 19.5 12.38 19.5 15.25C19.5 16.688 19.5 17.711 18.896 18.46C18.201 19.323 16.936 19.5 15.25 19.5Z"
      fill={stroke}
    />
  </svg>
)

export const ChatsIcon = ({
  width,
  height,
  fill = 'none',
  stroke = 'white',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 24 24'}
    fill={fill}
  >
    <path
      d="M11.9998 1.50001C10.1938 1.49926 8.41826 1.96459 6.8448 2.85099C5.27135 3.73739 3.95327 5.01485 3.01808 6.5598C2.08289 8.10476 1.56223 9.86491 1.50647 11.67C1.45071 13.4751 1.86174 15.264 2.69979 16.8638L1.52229 21.5685C1.49472 21.679 1.4927 21.7944 1.51637 21.9058C1.54004 22.0173 1.58879 22.1219 1.65891 22.2116C1.72903 22.3014 1.81869 22.3741 1.92107 22.424C2.02345 22.474 2.13587 22.5 2.24979 22.5C2.31124 22.5001 2.37247 22.4926 2.43204 22.4775L7.13604 21.3C8.54692 22.0395 10.1075 22.4483 11.6998 22.4954C13.292 22.5425 14.8741 22.2268 16.3262 21.5721C17.7784 20.9173 19.0625 19.9408 20.0814 18.7164C21.1003 17.4919 21.8273 16.0517 22.2073 14.5048C22.5873 12.9579 22.6104 11.3447 22.2747 9.78759C21.9391 8.23043 21.2536 6.77004 20.27 5.51701C19.2865 4.26397 18.0308 3.25113 16.598 2.55517C15.1651 1.85922 13.5927 1.49839 11.9998 1.50001ZM11.9998 21C10.4603 20.9988 8.94677 20.6027 7.60404 19.8495C7.49203 19.7866 7.36575 19.7536 7.23729 19.7535C7.17584 19.7533 7.11461 19.7609 7.05504 19.776L3.28104 20.7195L4.22454 16.9448C4.27034 16.7591 4.24351 16.563 4.14954 16.3965C3.18415 14.6721 2.81317 12.6779 3.09386 10.7217C3.37455 8.76552 4.2913 6.95609 5.70262 5.57272C7.11393 4.18936 8.94133 3.30898 10.9027 3.06746C12.8642 2.82595 14.8506 3.23674 16.5553 4.23643C18.26 5.23611 19.5883 6.7691 20.3352 8.59878C21.082 10.4285 21.2059 12.4531 20.6876 14.3602C20.1694 16.2672 19.0379 17.9507 17.4677 19.1507C15.8975 20.3508 13.976 21.0006 11.9998 21Z"
      fill={stroke}
    />
    <path
      d="M16.5 7.5H7.5C7.30109 7.5 7.11032 7.57902 6.96967 7.71967C6.82902 7.86032 6.75 8.05109 6.75 8.25C6.75 8.44891 6.82902 8.63968 6.96967 8.78033C7.11032 8.92098 7.30109 9 7.5 9H16.5C16.6989 9 16.8897 8.92098 17.0303 8.78033C17.171 8.63968 17.25 8.44891 17.25 8.25C17.25 8.05109 17.171 7.86032 17.0303 7.71967C16.8897 7.57902 16.6989 7.5 16.5 7.5Z"
      fill={stroke}
    />
    <path
      d="M16.5 11.25H7.5C7.30109 11.25 7.11032 11.329 6.96967 11.4697C6.82902 11.6103 6.75 11.8011 6.75 12C6.75 12.1989 6.82902 12.3897 6.96967 12.5303C7.11032 12.671 7.30109 12.75 7.5 12.75H16.5C16.6989 12.75 16.8897 12.671 17.0303 12.5303C17.171 12.3897 17.25 12.1989 17.25 12C17.25 11.8011 17.171 11.6103 17.0303 11.4697C16.8897 11.329 16.6989 11.25 16.5 11.25Z"
      fill={stroke}
    />
    <path
      d="M12 15H7.5C7.30109 15 7.11032 15.079 6.96967 15.2197C6.82902 15.3603 6.75 15.5511 6.75 15.75C6.75 15.9489 6.82902 16.1397 6.96967 16.2803C7.11032 16.421 7.30109 16.5 7.5 16.5H12C12.1989 16.5 12.3897 16.421 12.5303 16.2803C12.671 16.1397 12.75 15.9489 12.75 15.75C12.75 15.5511 12.671 15.3603 12.5303 15.2197C12.3897 15.079 12.1989 15 12 15Z"
      fill={stroke}
    />
  </svg>
)

export const ProfileIcon = ({ width, height, stroke }: any) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 15.3457C8.11731 15.3457 4.81445 15.9305 4.81445 18.2724C4.81445 20.6143 8.09636 21.22 11.9849 21.22C15.8525 21.22 19.1545 20.6343 19.1545 18.2933C19.1545 15.9524 15.8735 15.3457 11.9849 15.3457Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 12.0059C14.523 12.0059 16.5801 9.94779 16.5801 7.40969C16.5801 4.8716 14.523 2.81445 11.9849 2.81445C9.44679 2.81445 7.3887 4.8716 7.3887 7.40969C7.38013 9.93922 9.42394 11.9973 11.9525 12.0059H11.9849Z"
        stroke={stroke}
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const HelpIcon = ({
  width,
  height,
  fill = 'none',
  stroke = 'white',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 20 20'}
    fill={fill}
  >
    <path
      d="M9.49626 12.3258C9.49401 12.3258 9.49176 12.3258 9.48951 12.3258C9.07551 12.3221 8.74251 11.9835 8.74626 11.5691L8.74963 11.1941C8.74963 11.1727 8.75076 11.151 8.75301 11.1296C8.85688 10.0387 9.58101 9.37009 10.1634 8.83271C10.3606 8.65046 10.5474 8.47834 10.7064 8.29871C10.9003 8.08009 11.1815 7.63234 10.8856 7.09196C10.5448 6.46796 9.71226 6.29134 9.06538 6.43947C8.38963 6.59396 8.14063 7.17109 8.05213 7.50109C7.94488 7.90121 7.53351 8.13859 7.13338 8.03171C6.73326 7.92446 6.49588 7.51309 6.60276 7.11296C6.90163 5.99659 7.67713 5.21846 8.73013 4.97734C10.1473 4.65371 11.5745 5.22634 12.2011 6.37196C12.7228 7.32596 12.5799 8.44534 11.828 9.29359C11.6191 9.52909 11.396 9.73534 11.18 9.93446C10.6419 10.4313 10.3055 10.7636 10.2485 11.2432L10.2455 11.5818C10.2425 11.9947 9.90726 12.3258 9.49626 12.3258Z"
      fill={stroke}
    />
    <path
      d="M9.49512 14.5738C9.30012 14.5738 9.10512 14.495 8.96637 14.3563C8.82387 14.2175 8.74512 14.0225 8.74512 13.8238C8.74512 13.6288 8.82387 13.4338 8.96637 13.295C9.24387 13.0175 9.74637 13.0175 10.0239 13.295C10.1664 13.4338 10.2451 13.6288 10.2451 13.8238C10.2451 14.0225 10.1664 14.2138 10.0276 14.3563C9.88512 14.495 9.69387 14.5738 9.49512 14.5738Z"
      fill={stroke}
    />
    <path
      d="M9.72157 19.4854C8.86844 19.4854 8.02282 19.3744 7.20794 19.155C3.69644 18.2104 0.946942 15.3015 0.203317 11.7439C-0.554558 8.1195 0.844192 4.3095 3.76732 2.03738C5.45707 0.72375 7.58819 0 9.76844 0C11.2778 0 12.7767 0.351 14.1034 1.01438C17.3798 2.6535 19.4967 6.078 19.4967 9.73913C19.4967 12.7264 18.0871 15.6056 15.7261 17.4409C14.0303 18.7594 11.8977 19.4854 9.72157 19.4854ZM9.76882 1.5C7.92044 1.5 6.11594 2.11125 4.68832 3.22163C2.21444 5.14463 1.03019 8.36925 1.67182 11.4368C2.30107 14.4461 4.62719 16.9073 7.59794 17.7064C8.28569 17.8913 9.00044 17.9854 9.72157 17.9854C11.5658 17.9854 13.3714 17.3715 14.8058 16.2566C16.8042 14.7034 17.9971 12.267 17.9971 9.73913C17.9971 6.64125 16.2057 3.74325 13.4329 2.35613C12.3132 1.79625 11.0464 1.5 9.76882 1.5Z"
      fill={stroke}
    />
  </svg>
)

export const SettingIcon = ({
  width,
  height,
  fill = 'none',
  stroke = 'white',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 20 21'}
    fill={fill}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5281 6.34554L17.9057 5.26545C17.3791 4.35153 16.2121 4.03624 15.297 4.56064V4.56064C14.8613 4.81727 14.3415 4.89008 13.8521 4.76301C13.3628 4.63594 12.944 4.31944 12.6883 3.8833C12.5237 3.60607 12.4353 3.29032 12.432 2.96796V2.96796C12.4468 2.45115 12.2518 1.95033 11.8915 1.57959C11.5311 1.20886 11.036 0.999787 10.5189 1H9.26494C8.7584 0.999994 8.27275 1.20184 7.91544 1.56087C7.55812 1.9199 7.35861 2.40652 7.36105 2.91304V2.91304C7.34603 3.95885 6.49392 4.79873 5.448 4.79863C5.12565 4.79528 4.80989 4.70687 4.53267 4.54233V4.54233C3.6175 4.01794 2.45055 4.33322 1.92397 5.24714L1.25578 6.34554C0.729846 7.25832 1.04084 8.42453 1.95143 8.95423V8.95423C2.54334 9.29596 2.90797 9.92751 2.90797 10.611C2.90797 11.2945 2.54334 11.926 1.95143 12.2677V12.2677C1.04199 12.7939 0.730663 13.9573 1.25578 14.8673V14.8673L1.88736 15.9565C2.13408 16.4017 2.54804 16.7302 3.03763 16.8694C3.52722 17.0085 4.05208 16.9468 4.49606 16.6979V16.6979C4.93252 16.4433 5.45262 16.3735 5.94078 16.5041C6.42893 16.6348 6.84467 16.955 7.0956 17.3936C7.26013 17.6708 7.34854 17.9866 7.35189 18.3089V18.3089C7.35189 19.3655 8.20839 20.222 9.26494 20.222H10.5189C11.5719 20.222 12.4269 19.371 12.432 18.3181V18.3181C12.4295 17.81 12.6303 17.3219 12.9896 16.9626C13.3489 16.6034 13.8369 16.4026 14.345 16.405C14.6666 16.4136 14.9811 16.5017 15.2604 16.6613V16.6613C16.1731 17.1873 17.3394 16.8763 17.8691 15.9657V15.9657L18.5281 14.8673C18.7832 14.4294 18.8532 13.9079 18.7226 13.4183C18.5921 12.9287 18.2717 12.5113 17.8324 12.2586V12.2586C17.3932 12.0059 17.0728 11.5885 16.9422 11.0989C16.8117 10.6092 16.8817 10.0877 17.1368 9.64989C17.3027 9.36026 17.5428 9.12012 17.8324 8.95423V8.95423C18.7376 8.42482 19.0478 7.26542 18.5281 6.35469V6.35469V6.34554Z"
      stroke="#BCBCC2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="9.8969"
      cy="10.6108"
      r="2.63616"
      stroke="#BCBCC2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CardIcon = ({
  width,
  height,
  fill = 'none',
  stroke = 'white',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 25 25'}
    fill={fill}
  >
    <g opacity="0.8">
      <path
        d="M22 8.5013V7.3763C22 6.08764 20.9227 5.04297 19.5938 5.04297H2.40625C1.07731 5.04297 0 6.08764 0 7.3763V8.5013C0 8.61634 0.096207 8.70964 0.214844 8.70964H21.7852C21.9038 8.70964 22 8.61634 22 8.5013Z"
        fill="white"
      />
      <path
        d="M0 10.2493V17.3743C0 18.663 1.07731 19.7077 2.40625 19.7077H19.5938C20.9227 19.7077 22 18.663 22 17.3743V10.2493C22 10.1343 21.9038 10.041 21.7852 10.041H0.214844C0.096207 10.041 0 10.1343 0 10.2493ZM5.5 15.7077C5.5 16.0758 5.19217 16.3743 4.8125 16.3743H4.125C3.74533 16.3743 3.4375 16.0758 3.4375 15.7077V15.041C3.4375 14.6728 3.74533 14.3743 4.125 14.3743H4.8125C5.19217 14.3743 5.5 14.6728 5.5 15.041V15.7077Z"
        fill="white"
      />
    </g>
  </svg>
)

export const ClipShapeLeft = ({ width, height, fill = '#2E2D43' }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 243 243"
    fill={fill}
    preserveAspectRatio="none"
  >
    <rect width="100%" height="100%" fill={fill} />
  </svg>
)

export const ClipShapeRight = ({ width, height, fill = '#2E2D43' }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 194 291"
    fill={fill}
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      width="100%"
      height="100%"
      d="M194 0.463867L0.681519 291.001H194L194 0.463867Z"
      fill={fill}
    />
  </svg>
)

export const BackBtnIcon = ({
  width,
  height,
  fill = 'none',
  stroke = 'white',
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={'0 0 40 40'}
    fill={fill}
  >
    <rect width="40" height="40" rx="8" fill="white" fillOpacity="0.05" />
    <path
      d="M22.5 13L16 20L22.5 27"
      stroke="white"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export const FaceBookIcon = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2522_22897)">
      <path
        d="M20.5 10C20.5 4.47715 16.0229 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 14.9912 4.15684 19.1283 8.9375 19.8785V12.8906H6.39844V10H8.9375V7.79688C8.9375 5.29063 10.4305 3.90625 12.7146 3.90625C13.8084 3.90625 14.9531 4.10156 14.9531 4.10156V6.5625H13.6922C12.45 6.5625 12.0625 7.3334 12.0625 8.125V10H14.8359L14.3926 12.8906H12.0625V19.8785C16.8432 19.1283 20.5 14.9912 20.5 10Z"
        fill="white"
        fillOpacity="0.24"
      />
    </g>
    <defs>
      <clipPath id="clip0_2522_22897">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
export const TwitterIcon = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2522_24045)">
      <path
        d="M6.7918 18.1251C14.3371 18.1251 18.4652 11.8724 18.4652 6.45167C18.4652 6.27589 18.4613 6.0962 18.4535 5.92042C19.2566 5.33967 19.9496 4.62033 20.5 3.7962C19.7521 4.12896 18.958 4.34627 18.1449 4.44074C19.0011 3.92755 19.6421 3.12135 19.9492 2.17159C19.1438 2.64892 18.263 2.98563 17.3445 3.1673C16.7257 2.50976 15.9075 2.07439 15.0164 1.9285C14.1253 1.78261 13.211 1.93433 12.4148 2.3602C11.6186 2.78607 10.9848 3.46238 10.6115 4.28455C10.2382 5.10672 10.1462 6.02897 10.3496 6.9087C8.71874 6.82686 7.12328 6.40321 5.66665 5.6652C4.21002 4.9272 2.92474 3.89132 1.89414 2.62472C1.37033 3.52782 1.21005 4.59649 1.44586 5.61353C1.68167 6.63057 2.29589 7.51966 3.16367 8.10011C2.51219 8.07943 1.87498 7.90402 1.30469 7.58839V7.63917C1.3041 8.58691 1.63175 9.50561 2.23192 10.2391C2.8321 10.9726 3.66777 11.4756 4.59687 11.6626C3.99338 11.8277 3.35999 11.8518 2.7457 11.7329C3.00788 12.548 3.51798 13.2609 4.20481 13.7721C4.89164 14.2833 5.72093 14.5673 6.57695 14.5845C5.12369 15.726 3.32848 16.3452 1.48047 16.3423C1.15274 16.3418 0.825333 16.3217 0.5 16.2821C2.37738 17.4866 4.56128 18.1263 6.7918 18.1251Z"
        fill="white"
        fillOpacity="0.24"
      />
    </g>
    <defs>
      <clipPath id="clip0_2522_24045">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
export const DiscordIcon = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2522_23581)">
      <path
        d="M17.4308 3.4629C16.1561 2.87799 14.7892 2.44707 13.3599 2.20025C13.3339 2.19549 13.3079 2.20739 13.2945 2.2312C13.1187 2.54388 12.9239 2.9518 12.7876 3.27242C11.2503 3.04228 9.72099 3.04228 8.21527 3.27242C8.07887 2.94467 7.87707 2.54388 7.70048 2.2312C7.68707 2.20819 7.66107 2.19629 7.63504 2.20025C6.20659 2.44628 4.83963 2.87721 3.56411 3.4629C3.55307 3.46766 3.54361 3.4756 3.53732 3.48591C0.944493 7.35954 0.234208 11.138 0.58265 14.8695C0.584227 14.8878 0.594475 14.9053 0.608665 14.9164C2.31934 16.1726 3.97642 16.9353 5.60273 17.4408C5.62876 17.4488 5.65634 17.4393 5.6729 17.4178C6.05761 16.8925 6.40054 16.3385 6.69456 15.756C6.71192 15.7219 6.69535 15.6814 6.65989 15.6679C6.11594 15.4616 5.598 15.21 5.09977 14.9243C5.06037 14.9013 5.05721 14.8449 5.09347 14.8179C5.19831 14.7394 5.30318 14.6576 5.4033 14.5751C5.42141 14.56 5.44665 14.5568 5.46794 14.5664C8.74107 16.0608 12.2846 16.0608 15.5191 14.5664C15.5404 14.5561 15.5657 14.5592 15.5846 14.5743C15.6847 14.6568 15.7895 14.7394 15.8952 14.8179C15.9314 14.8449 15.9291 14.9013 15.8897 14.9243C15.3914 15.2155 14.8735 15.4616 14.3288 15.6671C14.2933 15.6806 14.2775 15.7219 14.2949 15.756C14.5952 16.3377 14.9381 16.8917 15.3157 17.417C15.3315 17.4393 15.3599 17.4488 15.3859 17.4408C17.0201 16.9353 18.6772 16.1726 20.3879 14.9164C20.4028 14.9053 20.4123 14.8886 20.4139 14.8703C20.8309 10.5562 19.7154 6.80878 17.4568 3.4867C17.4513 3.4756 17.4419 3.46766 17.4308 3.4629ZM7.18335 12.5974C6.19792 12.5974 5.38594 11.6927 5.38594 10.5816C5.38594 9.47056 6.18217 8.56585 7.18335 8.56585C8.19239 8.56585 8.99651 9.4785 8.98073 10.5816C8.98073 11.6927 8.18451 12.5974 7.18335 12.5974ZM13.829 12.5974C12.8435 12.5974 12.0316 11.6927 12.0316 10.5816C12.0316 9.47056 12.8278 8.56585 13.829 8.56585C14.838 8.56585 15.6421 9.4785 15.6264 10.5816C15.6264 11.6927 14.838 12.5974 13.829 12.5974Z"
        fill="white"
        fillOpacity="0.24"
      />
    </g>
    <defs>
      <clipPath id="clip0_2522_23581">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
export const CopyIcon = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M3.502 14.6495H3.50218H4.4988C4.67074 14.6495 4.83564 14.5812 4.95722 14.4596C5.0788 14.338 5.14711 14.1731 5.14711 14.0012C5.14711 13.8293 5.0788 13.6644 4.95722 13.5428C4.83564 13.4212 4.67074 13.3529 4.4988 13.3529H3.50234C3.1429 13.3525 2.7983 13.2095 2.54414 12.9554C2.29 12.7012 2.14704 12.3567 2.14662 11.9973C2.14662 11.9972 2.14662 11.9972 2.14662 11.9972V3.00234C2.14662 3.00231 2.14662 3.00227 2.14662 3.00224C2.14704 2.64284 2.29 2.29828 2.54414 2.04414C2.79828 1.79 3.14284 1.64704 3.50224 1.64662C3.50227 1.64662 3.50231 1.64662 3.50234 1.64662H12.4972C12.4972 1.64662 12.4972 1.64662 12.4973 1.64662C12.8567 1.64704 13.2012 1.79 13.4554 2.04414C13.7095 2.2983 13.8525 2.6429 13.8529 3.00234V3.9988C13.8529 4.17074 13.9212 4.33564 14.0428 4.45722C14.1644 4.5788 14.3293 4.64711 14.5012 4.64711C14.6731 4.64711 14.838 4.5788 14.9596 4.45722C15.0812 4.33564 15.1495 4.17074 15.1495 3.9988L15.1495 3.00218L15.1495 3.002C15.1487 2.2989 14.869 1.62484 14.3718 1.12768C13.8747 0.630514 13.2006 0.350839 12.4975 0.35H12.4973L3.50218 0.35L3.502 0.35C2.7989 0.350839 2.12484 0.630514 1.62768 1.12768C1.13051 1.62484 0.850839 2.2989 0.85 3.002V3.00218L0.85 11.9973L0.85 11.9975C0.850839 12.7006 1.13051 13.3747 1.62768 13.8718C2.12484 14.369 2.7989 14.6487 3.502 14.6495Z"
      fill="#81808C"
      stroke="#81808C"
      strokeWidth="0.3"
    />
    <path
      d="M15.5051 17.65L15.5053 17.65C16.2065 17.6492 16.8787 17.3703 17.3745 16.8745C17.8703 16.3787 18.1492 15.7065 18.15 15.0053V15.0051L18.15 5.99536L18.15 5.99518C18.1492 5.29402 17.8703 4.62182 17.3745 4.12603C16.8787 3.63023 16.2065 3.35133 15.5053 3.35049H15.5051L6.49536 3.35049L6.49518 3.35049C5.79402 3.35133 5.12182 3.63023 4.62603 4.12603C4.13023 4.62182 3.85133 5.29402 3.85049 5.99518V5.99536L3.85049 15.0051L3.85049 15.0053C3.85133 15.7065 4.13023 16.3787 4.62603 16.8745C5.12182 17.3703 5.79402 17.6492 6.49518 17.65H6.49536L15.5051 17.65ZM5.54258 5.04258C5.79534 4.78982 6.13802 4.64761 6.49547 4.64711C6.4955 4.64711 6.49553 4.64711 6.49556 4.64711H15.5049C15.505 4.64711 15.505 4.64711 15.505 4.64711C15.8625 4.64761 16.2051 4.78982 16.4579 5.04258C16.7107 5.29536 16.8529 5.63807 16.8534 5.99556V15.005C16.853 15.3625 16.7108 15.7052 16.458 15.958C16.2052 16.2108 15.8625 16.353 15.505 16.3534H6.49556C6.13807 16.3529 5.79536 16.2107 5.54258 15.9579C5.28982 15.7051 5.14761 15.3625 5.14711 15.005C5.14711 15.005 5.14711 15.005 5.14711 15.0049V5.99556C5.14711 5.99553 5.14711 5.9955 5.14711 5.99547C5.14761 5.63802 5.28982 5.29534 5.54258 5.04258Z"
      fill="#81808C"
      stroke="#81808C"
      strokeWidth="0.3"
    />
  </svg>
)
export const UsersIcon = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09151 13.207C11.7805 13.207 14.9335 13.766 14.9335 15.999C14.9335 18.232 11.8015 18.807 8.09151 18.807C4.40151 18.807 1.24951 18.253 1.24951 16.019C1.24951 13.785 4.38051 13.207 8.09151 13.207Z"
      stroke="white"
      strokeOpacity="0.24"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09157 10.02C5.66957 10.02 3.70557 8.057 3.70557 5.635C3.70557 3.213 5.66957 1.25 8.09157 1.25C10.5126 1.25 12.4766 3.213 12.4766 5.635C12.4856 8.048 10.5356 10.011 8.12257 10.02H8.09157Z"
      stroke="white"
      strokeOpacity="0.24"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9832 8.88177C16.5842 8.65677 17.8172 7.28277 17.8202 5.61977C17.8202 3.98077 16.6252 2.62077 15.0582 2.36377"
      stroke="white"
      strokeOpacity="0.24"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0955 12.7324C18.6465 12.9634 19.7295 13.5074 19.7295 14.6274C19.7295 15.3984 19.2195 15.8984 18.3955 16.2114"
      stroke="white"
      strokeOpacity="0.24"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BackArrowIcon = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M10 0L3.5 7L10 14"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)

export const NextArrowIcon = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M01 0L7 7L01 14"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)
